<template>
  <!-- Comments section - displays a list of comments for the pass if any exist -->
  <div v-if="comments?.length" class="active-pass-comments-cnt">
    <!-- Comments section header -->
    <div class="fw-bold pb-1">{{ $t("common.comments") }}:</div>

    <!-- Comment list - iterates through each comment -->
    <div
      v-for="(item, index) in comments"
      :key="index"
      class="active-pass-comments pb-1"
      data-test-id="student-active-pass-comment"
    >
      <!-- Comment timestamp -->
      <strong>[{{ formatDate(item?.created_at) }}]</strong>

      <!-- Comment text -->
      {{ item?.comment }}

      <!-- Comment author - shows user name or System -->
      <strong v-if="item?.user && item?.user !== 0">
        ({{ getUserName(item?.user) }})
      </strong>
      <strong v-else>({{ $t("common.system") }})</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: "PassCommentsList"
}
</script>

<script setup>
import helpers from "@/helpers/index"

defineProps({
  comments: {
    type: Array,
    default: () => []
  }
})

const formatDate = (date) => {
  return helpers.formatDate?.(date, "", "h:mm A") || date
}

const getUserName = (user) => {
  if (!user) return ""
  return `${user?.first_name || ""} ${user?.last_name || ""}`.trim()
}
</script>
